import { CSSObject } from '@chakra-ui/react';

export const TabsContentContainer: CSSObject = {
  px: '0',
  py: '0',
};
